'use strict';

const React = require('react'),
    OrderStore = require('stores/OrderStore'),
    {t} = require('services/i18nextWrapper'),
    AppDispatcher = require('dispatcher/SchedulerAppDispatcher'),
    _ = require('lodash'),
    DashboardModalSingleNew = require('components/DashboardModal/DashboardModalSingle/DashboardModalSingleNew'),
    DashboardModalSingleChange = require('components/DashboardModal/DashboardModalSingle/DashboardModalSingleChange'),
    DashboardModalBrewNew = require('components/DashboardModal/DashboardModalBrew/DashboardModalBrewNew'),
    DashboardModalBrewChange = require('components/DashboardModal/DashboardModalBrew/DashboardModalBrewChange'),
    BrewhouseStore = require('stores/BrewhouseStore'),
    DashboardModalStore = require('stores/DashboardModalStore'),
    SessionStore = require('stores/SessionStore'),
    DashboardStore = require('stores/DashboardStore'),
    ContentUtils = require('utils/ContentUtils'),
    NumberUtils = require('utils/NumberUtils'),
    DashboardActionCreator = require('actions/DashboardActionCreators'),
    ga = require('react-ga'),
    categories = require('constants/AppConstants').Analytics.categories,
    actions = require('constants/AppConstants').Analytics.actions,
    {
        // Combinations allowed of state of toggles
        TOGGLE_BT,
        TOGGLE_FV,
        TOGGLE_FV_BT,
        TOGGLE_BH,
        TOGGLE_BH_FV,
        TOGGLE_BH_BT,
        TOGGLE_BH_FV_BT,
        TOGGLE_BH_FV_BH,
        TOGGLE_BH_BT_BH
    } = require('constants/AppConstants'),
    ActionTypes = require('constants/AppConstants').ActionTypes,
    {formatProperOrderSelected} = require('components/DashboardModal/DashboardModalUtils'),
    {
        Dialog,
        FlatButton,
        Toggle,
        TextField
    } = require('material-ui'),
    toggleStyle = {
        float: 'left',
        width: '85px'
    },
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder');

const EMPTY_ELEMENT = (React.createElement("div", null));
let labelStyle = () => {
    return {
        left: '10px',
        transform: 'perspective(1px) scale(0.85) translate3d(10px, -28px, 0)',
        transformOrigin: 'left top'
    };
};

let DashboardModal = React.createClass({displayName: "DashboardModal",

    _ref: {},

    _lastDiffVolume: 0,

    getInitialState() {
        return DashboardModalStore.getInitialState();
    },

    componentWillMount() {
        DashboardModalStore.addChangeListener(this._onChangeDashboardModal);
    },

    componentWillUnmount() {
        DashboardModalStore.removeChangeListener(this._onChangeDashboardModal);
    
        if (this._ref.toggleBH) {
            this._ref.toggleBH.querySelector('input[type="checkbox"]').removeEventListener('change', this._nonAbleToChangeToggles);
        }
    
        if (this._ref.toggleFV) {
            this._ref.toggleFV.querySelector('input[type="checkbox"]').removeEventListener('change', this._nonAbleToChangeToggles);
        }
    
        if (this._ref.toggleBT) {
            this._ref.toggleBT.querySelector('input[type="checkbox"]').removeEventListener('change', this._nonAbleToChangeToggles);
        }
    },

    _onChangeDashboardModal() {
    },

    /**
     * needed time out to calculate an imperative way the total batch volume.
     */
    _timeout: null,

    //TODO: could be improve this `shouldComponentUpdate`
    shouldComponentUpdate() {
        return true;//nextProps.shouldUpdate;
    },

    componentDidMount() {
        if (this._ref.toggleBH) {
            this._ref.toggleBH.querySelector('input[type="checkbox"]').addEventListener('change', this._nonAbleToChangeToggles);
        }

        if (this._ref.toggleFV) {
            this._ref.toggleFV.querySelector('input[type="checkbox"]').addEventListener('change', this._nonAbleToChangeToggles);
        }

        if (this._ref.toggleBT) {
            this._ref.toggleBT.querySelector('input[type="checkbox"]').addEventListener('change', this._nonAbleToChangeToggles);
        }
    },

    componentDidUpdate() {
        let nextState = {};
        let callback = undefined;
        const modal = this._getModal(this.state);

        // Validate field error only once refs already been there.
        if (this.state.shouldNeedValidate && modal) {
            const modalEl = this.refs[modal.refName];
            if (modalEl) {
                const resultValidation = modalEl.isValidForm();

                if (resultValidation.isValid !== undefined && !resultValidation.isValid) {
                    nextState = _.merge(nextState, resultValidation.messagesError);
                }
                nextState.shouldNeedValidate = false;
            }
        }

        if (this._ref.toggleBH) {
            this._ref.toggleBH.setToggled(this.state.isBHAllowed);
        }

        if (this._ref.toggleFV) {
            this._ref.toggleFV.setToggled(this.state.isFVAllowed);
        }

        if (this._ref.toggleBT) {
            this._ref.toggleBT.setToggled(this.state.isBTAllowed);
        }

        //TODO: when update to material-ui 15v use show/dismiss props instead of current imperative way (`this.modalOrder.dismiss/show()`).
        if (this.state.triggerOpen) {
            nextState.triggerOpen = false;
            nextState.isOpen = true;
            callback = () => {
                if (this.modalOrder) {
                    this.modalOrder.show();
                }
            };

        } else if (this.state.triggerClose) {
            nextState.triggerClose = false;
            nextState.isOpen = false;
            callback = () => {
                if (this.modalOrder) {
                    this.modalOrder.dismiss();
                }
            };
        }

        // trigger only one setState
        if (Object.keys(nextState).length > 0) {
            this.setState(nextState, callback);
        }

        if (this._timeout) {
            clearTimeout(this._timeout);
        }
    },

    openExistingOrder(order,
                      orderDateClicked,
                      isFermenterTankClicked,
                      tankType,
                      openGeneralTab,
                      fermentingVolume,
                      packagingVolume,
                      totalBatchVolume,
                      totalBatchVolumeMessageError,
                      tankClicked,
                      totalBatchCost) {

        this.setState(Object.assign({
                totalBatchCost,
                order: formatProperOrderSelected(order),
                isTransfer: true,
                isFermenterTankClicked,
                orderDateClicked: orderDateClicked,
                isOpen: true,
                forceDisableToggle: false,
                isSingle: false,
                tankType,
                triggerOpen: true,
                isNewModal: false,
                batchNumber: order.batchNumber,
                isBHAllowed: _.get(order, 'batchs.length', 0) > 0,
                openGeneralTab,
                fermentingVolume,
                packagingVolume,
                totalBatchVolume,
                totalBatchVolumeMessageError,
                tankClicked
            }
            , _getToggleState(order)), () => {
            AppDispatcher.dispatch({
                type: ActionTypes.DASHBOARD_MODAL_OPEN_EXISTING_ORDER,
                order: this.state.order,
                volume: this.refs.dashboardModalChild.state.orderVolume, // take the last order volume defined
                batchNumber: this._ref.batchNumber.getValue(),
                isSingle: !(this.state.isFVAllowed && this.state.isBTAllowed)
            });
        });
    },

    openExistingSingleOrder(order,
                            orderDateClicked,
                            isFermenterTankClicked,
                            tankType,
                            openGeneralTab,
                            fermentingVolume,
                            packagingVolume,
                            totalBatchVolume,
                            totalBatchVolumeMessageError,
                            tankClicked) {

        this.setState(Object.assign({
            order: formatProperOrderSelected(order),
            isFermenterTankClicked,
            tankType,
            orderDateClicked,
            isTransfer: false,
            isSingle: true,
            isOpen: true,
            triggerOpen: true,
            isNewModal: false,
            forceDisableToggle: false,
            batchNumber: order.batchNumber,
            isBHAllowed: _.get(order, 'batchs.length', 0) > 0,
            openGeneralTab,
            totalBatchVolume,
            fermentingVolume,
            packagingVolume,
            totalBatchVolumeMessageError,
            tankClicked
        }, _getToggleState(order)), () => {
            AppDispatcher.dispatch({
                type: ActionTypes.DASHBOARD_MODAL_OPEN_EXISTING_ORDER,
                order: this.state.order,
                volume: this.refs.dashboardModalChild.state.orderVolume, // take the last order volume defined
                batchNumber: this._ref.batchNumber.getValue(),
                isSingle: !(this.state.isFVAllowed && this.state.isBTAllowed)
            });
        });
    },

    openNewOrder(preDefinedOrder) {
        if (DashboardStore.isPublishingDraft()) {
            Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
            return;
        }
        const isBrewhouseSection = _.get(preDefinedOrder, 'tankSelected.type') === 'BH';
        if (isBrewhouseSection) {
            const selectedTankAndDateClicked = BrewhouseStore.updateTankSelectionBrewhouseElegible(preDefinedOrder);
            let predefinedOrder = formatProperOrderSelected(selectedTankAndDateClicked);
            predefinedOrder.date = selectedTankAndDateClicked.orderDateClicked;
            predefinedOrder.tankTypeClicked = preDefinedOrder.tankType;

            this.setState({
                order: predefinedOrder,
                isOpen: true,
                isSingle: false,
                isTransfer: true,
                triggerOpen: true,
                isNewModal: true,
                // defult all toggles are open
                isBHAllowed: true,
                isFVAllowed: true,
                isBTAllowed: true,
                forceDisableToggle: false,

                tankSelected: selectedTankAndDateClicked.tankSelected,
                batchNumber: preDefinedOrder.batchNumber || OrderStore.getNextBatchNumber(),
                tankType: preDefinedOrder.tankType,
                totalBatchVolume: _.get(preDefinedOrder, 'tankSelected.volume'),
                totalBatchVolumeMessageError: _.get(preDefinedOrder, 'totalBatchVolumeMessageError')
            }, () => {
                AppDispatcher.dispatch({
                    type: ActionTypes.DASHBOARD_MODAL_OPEN_NEW_ORDER,
                    volume: this.refs.dashboardModalChild.state.orderVolume, // take the last order volume defined
                    batchNumber: this._ref.batchNumber.getValue(),
                    isSingle: !(this.state.isFVAllowed && this.state.isBTAllowed)
                });
            });
        } else {

            let formatOrder = formatProperOrderSelected(preDefinedOrder);
            formatOrder.tankTypeClicked = preDefinedOrder.tankType;

            this.setState({
                order: formatOrder,
                isOpen: true,
                isTransfer: true,
                triggerOpen: true,
                isNewModal: true,
                tankSelected: preDefinedOrder.tankSelected,
                batchNumber: preDefinedOrder.batchNumber || OrderStore.getNextBatchNumber(),
                tankType: preDefinedOrder.tankType,
                totalBatchVolume: _.get(preDefinedOrder, 'tankSelected.volume'),
                totalBatchVolumeMessageError: _.get(preDefinedOrder, 'totalBatchVolumeMessageError')
            }, () => {
                AppDispatcher.dispatch({
                    type: ActionTypes.DASHBOARD_MODAL_OPEN_NEW_ORDER,
                    volume: this.refs.dashboardModalChild.state.orderVolume, // take the last order volume defined
                    batchNumber: this._ref.batchNumber.getValue(),
                    isSingle: !(this.state.isFVAllowed && this.state.isBTAllowed)
                });
            });
        }
    },

    close() {
        if (this.isMounted()) {
            if (this.modalOrder) {
                this.modalOrder.dismiss();
            }
            this._lastDiffVolume = 0;
            const batchNumber = _.get(this.state, 'order.batchNumber');
            const modalEl = this._getModal(this.state);
            DashboardModalStore.setCurrentLayout(null);

            if (modalEl) {
                const modalRefName = modalEl.refName;
                const modal = this.refs[modalRefName];
                if (modal) {
                    modal.clean();
                }
                this.setState(DashboardModalStore.getInitialState(), () => {
                    DashboardActionCreator.executeBatchOperationsEnd(batchNumber);
                }); // reset state of modal
            }
        }
    },

    updateVolumeLabels(batchVolumeInfo) {
        // update total batch volume with order volume left `10bbl (5bbl left)`
        this._updateBatchVolumeLeftLabel(batchVolumeInfo);
    },
    
    updateBatchCostLabel(order) {
        this._ref.totalBatchCost.setValue(_.get(order, 'totalBatchCost'));
    },

    _updateBatchVolumeLeftLabel(order) {
        this._ref.batchTotalVolume.setValue(_.get(order, 'volume'));
    },

    _removeAndClose() {
        this.close();
        CustomDialog.showWarningConfirmation(t('warning'), t('notification_confirm_delete_orden'), () => {
            OrderStore.removeOrder(this.state.order);
            ga.event({
                category: categories.ORDER,
                action: actions.DELETE,
                label: 'Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
            });
        });
    },

    _saveAndClose() {
        const modalEl = this._getModal(this.state);
        if (modalEl) {
            const modalRefName = modalEl.refName;
            const modal = this.refs[modalRefName];
            modal.submit(this._ref, () => this.close());
        }
    },

    _getSingleNew(state, title, currentSection, sectionName, isBHAllowed, isFVAllowed, isBTAllowed) {
        const {isTransfer, order, tankSelected, tankType, openGeneralTab, shouldNotUpdateChildren} = state;
        return {
            currentSection,
            title,
            refName: 'dashboardModalChild',
            el: (
                React.createElement(DashboardModalSingleNew, {
                    ref: "dashboardModalChild", 
                    isSingleMode: isTransfer, 
                    isBHAllowed: isBHAllowed, 
                    isBTAllowed: isBTAllowed, 
                    isFVAllowed: isFVAllowed, 
                    preDefinedOrder: order, 
                    tankSelected: tankSelected, 
                    isNew: true, 
                    initFromDate: order.date, 
                    onActiveFirstTab: this._onChangeTab, 
                    tankTypeClicked: tankType, 
                    currentSection: currentSection, 
                    sectionName: sectionName, 
                    openGeneralTab: openGeneralTab, 
                    shouldNotUpdate: shouldNotUpdateChildren}
                )
            )
        };
    },

    _getSingleChange(state, title, currentSection, sectionName, isBHAllowed, isFVAllowed, isBTAllowed) {
        const {order, orderDateClicked, tankSelected, openGeneralTab, shouldNotUpdateChildren, tankClicked} = state;
        return {
            currentSection,
            title,
            refName: 'dashboardModalChild',
            el: (
                React.createElement(DashboardModalSingleChange, {
                    ref: "dashboardModalChild", 
                    isBHAllowed: isBHAllowed, 
                    isBTAllowed: isBTAllowed, 
                    isFVAllowed: isFVAllowed, 
                    orderDateClicked: orderDateClicked, 
                    order: order, 
                    tankSelected: tankSelected, 
                    onActiveFirstTab: this._onChangeTab, 
                    currentSection: currentSection, 
                    sectionName: sectionName, 
                    openGeneralTab: openGeneralTab, 
                    tankClicked: tankClicked || currentSection, 
                    shouldNotUpdate: shouldNotUpdateChildren}
                )
            )
        };
    },

    _getCombinedNew(state, title, isBHAllowed, isFVAllowed, isBTAllowed) {
        const {isTransfer, order, orderDateClicked, tankSelected, tankType, openGeneralTab, shouldNotUpdateChildren} = state;
        return {
            title,
            refName: 'dashboardModalChild',
            el: (
                React.createElement(DashboardModalBrewNew, {
                    ref: "dashboardModalChild", 
                    isSingleMode: isTransfer, 
                    isBHAllowed: isBHAllowed, 
                    isBTAllowed: isBTAllowed, 
                    isFVAllowed: isFVAllowed, 
                    tankSelected: tankSelected, 
                    tankTypeClicked: tankType, 
                    orderDateClicked: orderDateClicked, 
                    order: order, 
                    onActiveFirstTab: this._onChangeTab, 
                    openGeneralTab: openGeneralTab, 
                    shouldNotUpdate: shouldNotUpdateChildren}
                )
            )
        };
    },

    _getCombinedChange(state, title, isBHAllowed, isFVAllowed, isBTAllowed) {
        const {isNewModal, order, isFermenterTankClicked, orderDateClicked, tankType, openGeneralTab, shouldNotUpdateChildren, tankClicked} = state;
        return {
            title,
            refName: 'dashboardModalChild',
            el: (
                React.createElement(DashboardModalBrewChange, {
                    ref: "dashboardModalChild", 
                    isSingleMode: isNewModal, 
                    isBHAllowed: isBHAllowed, 
                    isBTAllowed: isBTAllowed, 
                    isFVAllowed: isFVAllowed, 
                    tankTypeClicked: tankType, 
                    isFermenterTankClicked: isFermenterTankClicked, 
                    orderDateClicked: orderDateClicked, 
                    order: order, 
                    tankClicked: tankClicked, 
                    onActiveFirstTab: this._onChangeTab, 
                    openGeneralTab: openGeneralTab, 
                    shouldNotUpdate: shouldNotUpdateChildren}
                )
            )
        };
    },

    _getCombinedNewFromBrewHouse(state) {
        return this._getCombinedNew(state);
    },

    _getCombinedChangeFromBrewhouse(state) {
        return this._getCombinedChange(state);
    },

    _onToggle(name) {
        const toggleConditional = `is${name}Allowed`;
        let order = this.state.order;

        let toggleConditions = [];
        const newStateToggle = !this.state[toggleConditional];
        toggleConditions.push({name: 'isBHAllowed', state: this.state.isBHAllowed});
        toggleConditions.push({name: 'isBTAllowed', state: this.state.isBTAllowed});
        toggleConditions.push({name: 'isFVAllowed', state: this.state.isFVAllowed});

        toggleConditions = _.filter(toggleConditions, toggle => toggle.name !== toggleConditional);
        toggleConditions.push({name: toggleConditional, state: newStateToggle});

        if (_.every(toggleConditions, toggles => !toggles.state)) {
            // enter here means that all the toggles are off
            this.close();
            return;
        }

        if (order) {
            const isCombinedOrder = _.get(_.find(toggleConditions, toggle => toggle.name === 'isBTAllowed'), 'state') &&
                _.get(_.find(toggleConditions, toggle => toggle.name === 'isFVAllowed'), 'state');
            order.isSingle = !isCombinedOrder;

            if (order.tankSelected && order.isSingle) {
                order.singleTank = order.tankSelected;
                order.tankSelected = null;
            }
        }

        this.setState(prevState => {
            return {
                [toggleConditional]: !prevState[toggleConditional],
                order
            };
        }, () => {
            DashboardActionCreator.changeToggle(toggleConditional, this.state.isBHAllowed, this.state.isFVAllowed, this.state.isBTAllowed);
        });
    },

    _onChangeStore() {
    },

    _onChangeBatchNumber() {
        AppDispatcher.dispatch({
            type: ActionTypes.DASHBOARD_MODAL_CHANGE_NUMBER,
            order: this.state.order,
            volume: this.refs.dashboardModalChild.state.orderVolume, // take the last order volume defined
            batchNumber: this._ref.batchNumber.getValue(),
            isSingle: !(this.state.isFVAllowed && this.state.isBTAllowed)
        });
    },

    _onChangeTab(/*index*/) {
        //this.setState({
        //    currentTabSelected: _.get(index, 'props.tabIndex')
        //});
    },

    _getModal(state) {
        const modalKey = getToggleKey(state);
        switch (modalKey) {
            case TOGGLE_BT:         // single
                return state.isNewModal ?
                    this._getSingleNew(state, `${t('dashboard_modal_title_new')} ${t('packaging')}`, 'BT', t('packaging'), false, false, true) :
                    this._getSingleChange(state, `${t('dashboard_modal_title_edit')} ${t('packaging')}`, 'BT', t('packaging'), false, false, true);
            case TOGGLE_FV:         // single
                return state.isNewModal ?
                    this._getSingleNew(state, `${t('dashboard_modal_title_new')} ${t('fermenting')}`, 'FV', t('fermenting'), false, true, false) :
                    this._getSingleChange(state, `${t('dashboard_modal_title_edit')} ${t('fermenting')}`, 'FV', t('fermenting'), false, true, false);
            case TOGGLE_BH:         // single
                return state.isNewModal ?
                    this._getSingleNew(state, `${t('dashboard_modal_title_new')} ${t('brewing')}`, 'BH', t('brewing'), true, false, false) :
                    this._getSingleChange(state, `${t('dashboard_modal_title_edit')} ${t('brewing')}`, 'BH', t('brewing'), true, false, false);
            // All order with brewhouse  ------------------------
            case TOGGLE_BH_FV:      // single c/ BH  with tab open in FV
                return state.isNewModal ?
                    this._getSingleNew(state, `${t('dashboard_modal_title_new')} ${t('brewing')}-${t('fermenting')}`, 'FV', t('fermenting'), true, true, false) :
                    this._getSingleChange(state, `${t('dashboard_modal_title_edit')} ${t('brewing')}-${t('fermenting')}`, 'FV', t('fermenting'), true, true, false);
            case TOGGLE_BH_BT:      // single c/ BH with tab open in BT
                return state.isNewModal ?
                    this._getSingleNew(state, `${t('dashboard_modal_title_new')} ${t('brewing')}-${t('packaging')}`, 'BT', t('packaging'), true, false, true)
                    : this._getSingleChange(state, `${t('dashboard_modal_title_edit')} ${t('brewing')}-${t('packaging')}`, 'BT', t('packaging'), true, false, true);
            case TOGGLE_BH_FV_BH:      // single c/ BH with open in BH
                return state.isNewModal ?
                    this._getSingleNew(state, `${t('dashboard_modal_title_new')} ${t('brewing')}-${t('fermenting')}`, 'BH', t('fermenting'), true, true, false) :
                    this._getSingleChange(state, `${t('dashboard_modal_title_edit')} ${t('brewing')}-${t('fermenting')}`, 'BH', t('fermenting'), true, true, false);
            case TOGGLE_BH_BT_BH:      // single c/ BH with open in BH
                return state.isNewModal ?
                    this._getSingleNew(state, `${t('dashboard_modal_title_new')} ${t('brewing')}-${t('packaging')}`, 'BH', t('packaging'), true, false, true) :
                    this._getSingleChange(state, `${t('dashboard_modal_title_edit')} ${t('brewing')}-${t('packaging')}`, 'BH', t('packaging'), true, false, true);
            // all order without brewhouse ------------------------
            case TOGGLE_FV_BT:      // combined s/ BH
                return state.isNewModal ?
                    this._getCombinedNew(state, `${t('dashboard_modal_title_new')} ${t('fermenting')}-${t('packaging')}`, false, true, true) :
                    this._getCombinedChange(state, `${t('dashboard_modal_title_edit')} ${t('fermenting')}-${t('packaging')}`, false, true, true);
            case TOGGLE_BH_FV_BT:   // combined c/ BH
                return state.isNewModal ?
                    this._getCombinedNew(state, `${t('dashboard_modal_title_new')} ${t('brewing')}-${t('fermenting')}-${t('packaging')}`, true, true, true) :
                    this._getCombinedChange(state, `${t('dashboard_modal_title_edit')} ${t('brewing')}-${t('fermenting')}-${t('packaging')}`, true, true, true);
            default:
        }
    },

    _onToggleBH() {
        return this._onToggle('BH');
    },

    _onToggleFV() {
        return this._onToggle('FV');
    },

    _onToggleBT() {
        return this._onToggle('BT');
    },

    disableToggles(callback) {
        this._ref.toggleBH.setDisabled(true);
        this._ref.toggleFV.setDisabled(true);
        this._ref.toggleBT.setDisabled(true);
        if (callback) {
            callback();
        }
    },
    enableToggles(callback) {
        this._ref.toggleBH.setDisabled(false);
        this._ref.toggleFV.setDisabled(false);
        this._ref.toggleBT.setDisabled(false);
        if (callback) {
            callback();
        }
    },

    _setModal(_el) {
        this.modalOrder = _el;
    },

    _nonAbleToChangeToggles() {
        if (!this.state.isBHAllowed || !this.state.isFVAllowed || !this.state.isBTAllowed) {
            Notification.show(t('dashboard_notification_modal_section_must_be_choosen_before_beer_style'), 'error');
        }
    },

    render() {
        const {isNewModal, isOpen, currencyInfo} = this.state;

        if (!isOpen) {
            return EMPTY_ELEMENT;
        }

        const modal = this._getModal(this.state);
        if (!modal) {
            // some cases enter here when hit in close button
            return null;
        }
        const dashboardModalEl = modal.el;
        const modalTitle = modal.title;

        if (modal.currentSection !== 'BH') {
            toggleStyle.display = 'initial';
        }

        const batchNumberLabelStyle = {
            color: this.state.packagingVolume !== this.state.fermentingVolume ? 'orange' : '#B3B3B3'
        };

        const isEditable = SessionStore.isAdminUser();
    
        let actions = [
            React.createElement("div", {style: {
                display: this.state.isNewModal ? 'inline-block' : 'none',
                top: '15px',
                position: 'relative',
                float: 'left',
                marginLeft: '-6px'
            }}, 
                React.createElement(Toggle, {
                    style: toggleStyle, 
                    ref: input => this._ref.toggleBH = input, 
                    name: "toggleBH", 
                    label: t('label_brewing'), 
                    labelStyle: labelStyle(this.state.forceDisableToggle), 
                    defaultToggled: this.state.isBHAllowed, 
                    defaultValue: this.state.isBHAllowed, 
                    onToggle: this.state.forceDisableToggle ? this._nonAbleToChangeToggles : this._onToggleBH, 
                    disabled: this.state.forceDisableToggle}
                ), 
                React.createElement(Toggle, {
                    style: toggleStyle, 
                    ref: input => this._ref.toggleFV = input, 
                    name: "toggleFV", 
                    label: t('label_fermenting'), 
                    labelStyle: labelStyle(this.state.forceDisableToggle), 
                    defaultToggled: this.state.isFVAllowed, 
                    defaultValue: this.state.isFVAllowed, 
                    onToggle: this.state.forceDisableToggle ? this._nonAbleToChangeToggles : this._onToggleFV, 
                    disabled: this.state.forceDisableToggle}
                ), 
                React.createElement(Toggle, {
                    style: toggleStyle, 
                    ref: input => this._ref.toggleBT = input, 
                    name: "toggleBT", 
                    label: t('label_packaging'), 
                    labelStyle: labelStyle(this.state.forceDisableToggle), 
                    defaultToggled: this.state.isBTAllowed, 
                    defaultValue: this.state.isBTAllowed, 
                    onToggle: this.state.forceDisableToggle ? this._nonAbleToChangeToggles : this._onToggleBT, 
                    disabled: this.state.forceDisableToggle}
                )
            ),
            React.createElement("div", {className: "dashboard-modal-content__label-batch-number", style: {
                paddingLeft: this.state.isNewModal ? '20px' : '0'
            }}, 
                React.createElement(TextField, {
                    ref: input => this._ref.batchNumber = input, 
                    floatingLabelText: t('dashboard_modal_footer_batch_number'), 
                    multiLine: false, 
                    onBlur: this._onChangeBatchNumber, 
                    defaultValue: _.get(this.state, 'batchNumber', ''), 
                    style: {width: '110%'}, 
                    disabled: !isEditable
                }
                )
            )
            ,
            React.createElement("div", {style: {
                top: '-23px',
                position: 'relative',
                height: '75px',
                float: 'left',
                paddingLeft: this.state.isNewModal ? '20px' : '0',
                minWidth: '100px'
            }}, 
                React.createElement(TextField, {
                    ref: input => this._ref.batchTotalVolume = input, 
                    floatingLabelText: t('dashboard_modal_footer_batch_volume'), 
                    multiLine: false, 
                    defaultValue: _.get(this.state, 'totalBatchVolume', ''), 
                    errorStyle: batchNumberLabelStyle, 
                    style: {width: '100%', textAlign: 'left'}, 
                    disabled: true
                }
                )
            )
            ,
            React.createElement("div", {style: {
                top: '-23px',
                position: 'relative',
                height: '75px',
                float: 'left',
                paddingLeft: this.state.isNewModal ? '20px' : '0',
                minWidth: '100px',
                display: isNewModal ? 'none' : 'initial'
            }}, 
                React.createElement(TextField, {
                    ref: input => this._ref.totalBatchCost = input, 
                    floatingLabelText: t('dashboard_modal_footer_batch_cost'), 
                    multiLine: false, 
                    defaultValue: `${_.get(currencyInfo, 'symbol')} ${_.get(this.state, 'totalBatchCost', '')}`, 
                    errorStyle: batchNumberLabelStyle, 
                    style: {width: '100%', textAlign: 'left'}, 
                    disabled: true
                }
                )
            )
            ,
            React.createElement(FlatButton, {
                label: t('button_label_cancel'), 
                className: "dashboard-modal-content__button-cancel", 
                secondary: true, 
                onTouchTap: this.close, 
                "data-button": "cancel"
            }
            ),
            React.createElement(FlatButton, {
                style: {'display': isEditable ? 'inline' : 'none'}, 
                label: t('button_label_save'), 
                className: "dashboard-modal-content__button-save", 
                primary: true, 
                onTouchTap: this._saveAndClose, 
                "data-button": "save"
            }
            )
        ];

        if (!isNewModal) {
            if (modal.currentSection === 'BH') {
                // enter here means is a single change dialog from brewing section, so is not need to show the toggle BH because, singles
                // from brewing section can't have any batch.
                toggleStyle.display = 'none';
            }
            if (SessionStore.hasAdminUserPermission() || SessionStore.isAbleToEditDates()) {
                actions.splice(3, 0,
                  React.createElement(FlatButton, {
                    style: {'display': isEditable ? 'inline' : 'none'}, 
                    label: t('button_label_remove'), 
                    className: "dashboard-modal-content__button-remove", 
                    primary: true, 
                    onTouchTap: this._removeAndClose
                  }
                  )
                );
            }
        }

        return (
            React.createElement("div", {className: "modal-order"}, 
                React.createElement(Dialog, {
                    ref: this._setModal, 
                    title: modalTitle, 
                    actions: actions, 
                    actionFocus: "submit", 
                    hideToolbarYearChange: false, 
                    autoScrollBodyContent: true, 
                    autoDetectWindowHeight: true, 
                    modal: true, 
                    contentStyle: {minHeight: '420px !important', height: '420px', top: '-80px'}, 
                    contentClassName: "dashboard-modal-content"
                }, 
                    dashboardModalEl
                )
            )
        );
    }
});

/**
 * Calculate the type of Dialog is and retrieve the key that allow to be created.
 * @param state
 * @return {Object} current state context of modal.
 */
function getToggleKey(state) {
    let modalKey = 'TOGGLE';

    if (_.get(state, 'isBHAllowed')) {
        modalKey += '_BH';
    }

    if (_.get(state, 'isFVAllowed')) {
        modalKey += '_FV';
    }

    if (_.get(state, 'isBTAllowed')) {
        modalKey += '_BT';
    }

    return modalKey;
}


function _getToggleState(order) {
    let toggleState = {
        isBHAllowed: false,
        isFVAllowed: false,
        isBTAllowed: false
    };
    if (order && order.isSingle) {
        const tankType = _.get(order, 'singleTank.type');
        if (tankType === 'BH' || _.get(order.batchs, 'length') > 0) {
            toggleState.isBHAllowed = true;
        }
        if (tankType === 'FV') {
            toggleState.isFVAllowed = true;
        } else if (tankType === 'BT') {
            toggleState.isBTAllowed = true;
        }
    } else {
        if (_.get(order.batchs, 'length') > 0) {
            toggleState.isBHAllowed = true;
        }
        toggleState.isFVAllowed = true;
        toggleState.isBTAllowed = true;
    }

    return toggleState;

}

module.exports = DashboardModal;



/** WEBPACK FOOTER **
 ** ./src/components/DashboardModal/DashboardModal.jsx
 **/